export const MASTER_NOTES_MAX_LENGTH = 150;
export const MASTER_CITY_NAME_MAX = 50;
export const MASTER_ROOM_NAME_MAX = 50;
export const MASTER_BLOCK_FLOOR_NAME_MAX = 150;
export const MASTER_NAME_MIN_LENGTH = 2;

/** @returns {string|null} user-facing error or null */
export const validateMasterLocationName = (value, fieldLabel) => {
    const text = String(value ?? "").trim();
    if (text.length < MASTER_NAME_MIN_LENGTH) {
        return `${fieldLabel} must be at least ${MASTER_NAME_MIN_LENGTH} characters`;
    }
    if (!/[A-Za-z]/.test(text)) {
        return `${fieldLabel} must include at least one letter (not only digits or punctuation)`;
    }
    return null;
};

/** Pick the best API error string for location master saves. */
export const masterSaveErrorMessage = (response, fallback) => {
    if (response?.message && response.message !== "Validation failed") {
        return response.message;
    }
    const errors = response?.errors;
    if (errors && typeof errors === "object" && !Array.isArray(errors)) {
        const first = Object.values(errors).find(Boolean);
        if (first) return String(first);
    }
    return response?.message || fallback;
};
